import { render, staticRenderFns } from "./UserPanelSelect.vue?vue&type=template&id=67daf112"
import script from "./UserPanelSelect.vue?vue&type=script&lang=js"
export * from "./UserPanelSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports